import { render, staticRenderFns } from "./DynamicTitle.vue?vue&type=template&id=2e4c8b08"
import script from "./DynamicTitle.vue?vue&type=script&lang=ts"
export * from "./DynamicTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports